// jQuery(document).ready(function($) {
//     if(is_dev) {
//         setTimeout(function() {
//
//             $('input[value="25"]')[0].checked = true;
//             $('input[value="26"]')[0].checked = true;
//             $('input[value="25"]').trigger('change');
//             send_invoices();
//             setTimeout(function() {
//                 $('form.emails').submit();
//             },1000);
//         },500);
//     }
// });

var invoice_entity_ajax = {};
function add_invoice(vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/invoice/add',
        onOpen: function (elm, popup) {
            load_invoice_selectors(elm, vars);

            elm.find('form').ajaxFormSubmit(function(data, last_form){
                elm.doneLoading();
                if(last_form.hasClass('header-fields')) {
                    elm.find('form.choose-products').find('table').reloadThisElement();
                    elm.find('.address-options-wrapper').html(data);
                } else if(last_form.hasClass('add-notes')) {
                    load_paperwork_preview(elm, last_form, 'invoice');
                } else if(last_form.hasClass('submit')) {
                    $('body').isLoading();
                    reload_location_if_needed();
                    if (!document.closeWindow) open_new_object(view_invoice, data);
                }
                ajax_popup_scroll_to_next_screen(function() {
                    var a = elm.find('.scroll-screen.active');
                    var next_form = a.find('form');
                    next_form.find('input.generated-input').remove();
                    last_form.find(':input').each(function() {
                        var name = $(this).attr('name');
                        var type = $(this).attr('type');
                        if(name != undefined && type != 'submit' && name != "_token" && (type != "checkbox" || $(this).is(':checked'))) {
                            const v = $(this).val();
                            if ($(this).prop('tagName') === 'TEXTAREA') {
                                next_form.append('<textarea style="display: none;" name="' + $(this).attr('name') + '" class="generated-input">' + v + '</textarea>');
                            } else {
                                next_form.append('<input type="hidden" name="'+$(this).attr('name')+'" value="' + v + '" class="generated-input" />');
                            }
                        }
                    });
                }.bind([elm, last_form]));
            }.bind([elm,popup]), function(xhr, status, error) {
                elm.doneLoading();
                console.log([status,error]);
                ajax_popup_set_scroll_screen_progress(elm);
            }.bind([elm,popup]), function() {
                elm.isLoading();
            });
        }
    });
    return false;
}
function delete_invoice(id, identifier, close = false) {
    return delete_paperwork_object('invoice', id, identifier, close);
}
function view_invoice(id, callback) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/invoice/view/'+id,
        onOpen: function(elm, popup) {
            load_invoice_selectors(elm, { existing: true });

            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('invoice', id);

                $('body').doneLoading();
                squde_reload_for_flashes();
                if(callback) {
                    callback(data, elm, popup);
                }
                if (document.closeWindow) popup.close();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        },
    });
    return false;
}
function load_invoice_selectors(elm, vars, default_null_vall) {
    const $ = jQuery.noConflict();

    load_contact_and_company_selectors(elm, vars);

    $('[data-quotation-selector]').quotationSelector();
    $('[data-order-selector]').orderSelector();

    invoice_load_product_selector(elm);



    //Update the days for the payment condition
    elm.find('#payment_condition_id').change(function() {
        var condition_days = parseInt($(this).find('option[value='+$(this).val()+']').attr('data-days'));
        var from_date_str = elm.find('#invoice_date').val();
        var from_date = new Date();
        from_date.setMonth(from_date_str.split('-')[1]-1);
        from_date.setDate(from_date_str.split('-')[0]);
        from_date.setFullYear(from_date_str.split('-')[2]);

        var to_date = new Date(from_date);
        to_date.setDate(from_date.getDate() + condition_days);

        var to_str = (to_date.getDate() < 10 ? '0'+to_date.getDate().toString() : to_date.getDate())+'-'+((to_date.getMonth() + 1) < 10 ? '0'+(to_date.getMonth() + 1).toString() : (to_date.getMonth() + 1))+'-'+to_date.getFullYear();
        elm.find('#expires_at').val(to_str);

    }).trigger('change');
    elm.find('#invoice_date').bind('change keyup', function() {
        elm.find('#payment_condition_id').trigger('change');
    });
}
function invoice_load_product_selector(elm, client_id) {
    paperwork_load_product_selector(elm,invoice_entity_ajax, client_id);
}
function invoice_add_products(id, client_id) {
    paperwork_add_products('invoice', id, client_id);
    return false;
}
function remove_product_from_invoice(id, new_invoice) {
    var $ = jQuery.noConflict();

    if(new_invoice == undefined) {
        new_invoice = 0;
    }
    var after_confirm = function() {
        $.post('/administration/invoice/remove_product',{id:id, new_invoice:new_invoice}, function() {
            $('.invoice-products-table').reloadThisElement();
            if(new_invoice == 0) {
                squde_flash("Artikel van factuur verwijderd");
                reload_location_if_needed(false);
            }
        });
    }

    if(id != "new") {
        confirm("Weet u zeker dat u dit artikel van de factuur wilt verwijderen?", function() {
            after_confirm();
        });
    } else {
        after_confirm();
    }
}
function view_invoice_product(id, new_invoice, client_id) {
    view_paperwork_product('invoice', id, new_invoice, client_id);
    return false;
}
function change_invoice_status(id) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/invoice/status/'+id,
        size: 'tiny',
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                data = JSON.parse(data);
                if(data.sent == 1) {
                    downloadLoader();
                    location.href = "/administration/invoice/"+data.id;
                }
                $('body').append('<div class="i-am-loading"></div>');
                squde_reload_for_flashes();
                reload_location_if_needed();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function send_invoices() {
    var selection = window.selected_invoices;
    var $ = jQuery.noConflict();



    $.squdeAjaxPopup({
        url: '/administration/invoice/getSendWizard/',
        data: {selection: selection},
        onOpen: function(elm, popup) {

            elm.find('form.submit').submit(function() {
                var form = $(this);
                var data_wrapper = form.find('.data-wrapper');
                if(data_wrapper.length == 0) {
                    form.append('<div class="data-wrapper" style="display: none; "></div>');
                    data_wrapper = form.find('.data-wrapper');
                }
                data_wrapper.empty();
                $('.scroll-screen-container').find('.scroll-screen').each(function() {
                    if($(this).index() < form.parents('.scroll-screen').index()) {
                        data_wrapper.append($(this).find(':input').clone());
                    }
                });
            });
            elm.find('form').ajaxFormSubmit(function(data, form){
                $('body').doneLoading();
                if(form.hasClass('submit')) {
                    ajax_popup_scroll_to_next_screen(function() {
                        elm.find('.visual-icon-paper-plane').addClass('fly-in');
                    });
                } else {
                    ajax_popup_scroll_to_next_screen();
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het verzenden.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

jQuery(document).ready(function() {
    // if(is_dev) {
    //     window.selected_invoices = [36];
    //     register_invoices();
    // }
});

function register_invoices() {
    var selection = window.selected_invoices;
    var $ = jQuery.noConflict();



    $.squdeAjaxPopup({
        url: '/accounting/getWizard/',
        data: {selection: selection},
        onOpen: function(elm, popup) {
            if(elm.find('input#auth').val().length > 0) {
                setCookie('waiting_for_accounting_oauth', 0, -1);
                accounting_auth_check(elm.find('input#auth').val(), elm);
            }

            var form = elm.find('form.postSalesJournal');
            var wrapper = $('.screen-placeholder');
            var accountingName = form.attr('data-accounting-name');

            elm.find('form').ajaxFormSubmit(function(data, form){
                wrapper.doneLoading();

                if(data.tmp) {
                    wrapper.html("<pre>"+JSON.stringify(data.tmp, null, 2)+"</pre>");
                    return false;
                }

                if(data.errors && data.errors.length > 0) {
                    data.errors.forEach(function(err) {
                        wrapper.append('<div class="callout alert">'+err+'</div>');
                    });
                } else {
                    if(data.messages && data.messages.length > 0) {
                        data.messages.forEach(function(msg) {
                            $('.messages-wrapper').append('<div class="callout primary">'+msg+'</div>')
                        });
                    }
                    ajax_popup_scroll_to_next_screen(function() {
                        elm.find('.visual-icon-paper-plane').addClass('fly-in');
                    });
                }


            }.bind([elm,popup]), function(xhr, status, error) {
                wrapper.doneLoading();



                let err = null;
                try {

                    err = JSON.parse(xhr.responseText);
                    console.log(err);


                    const rows = JSON.parse(err.data);
                    rows.forEach(function(row) {
                        wrapper.append('<div class="callout alert"><b>'+accountingName+' fout: '+row.errorCode+'</b><br />'+row.message+'</div>');
                        if(row.details != null) {
                            wrapper.find('.callout:last').append('<br />'+row.details);
                        }
                    });

                    console.log(err.sendData);
                } catch(e) {
                    if (xhr.responseText.split('redirectTo').length > 1) {
                        setCookie('waiting_for_accounting_oauth', 0, -1);
                        accounting_auth_check(elm.find('input#auth').val(), elm);
                    }

                    squde_flash("Er ging iets mis bij het boeken.","alert");
                }
            }.bind([elm,popup]), function() {
                wrapper.empty();
                wrapper.isLoading();
            });
        }
    });
    return false;
}

function make_credit_invoice(id) {
    const $ = jQuery.noConflict();
    confirm("Weet u zeker dat u een creditfactuur wilt maken?", async () => {
        const invoice = await $.post(`/administration/invoice/${id}/make_credit_invoice`);
        reload_location_if_needed();
        squde_reload_for_flashes();
        view_invoice(invoice.id);
    });
}
function merge_invoice(id) {
    const $ = jQuery.noConflict();
    const body = $('body');

    (async () => {
        body.isLoading();
        const otherInvoices = await $.get(`/api/administration/invoices/${id}/getMergableInvoices`);
        body.doneLoading();

        if (otherInvoices.length === 0) {
            foundationPopup(`<div class="callout alert">Er zijn geen facturen om mee samen te voegen voor deze debiteur.</div>`, () => {}, 'small');
        } else {
            foundationPopup(`<h1>Facturen samenvoegen</h1><hr /><div class="squde-popup-html">

</div>`, function(elm, popup) {
                elm.find('br:first').remove();

                const table = $(`<table class="scrollable-table"></table>`);
                elm.find('.squde-popup-html').append(table);
                table.html(`<thead><tr><th><input type="checkbox" onchange="checkWholeTable(this)" checked /></th><th>Referentie</th><th style="text-align: right;">Totaalbedrag</th><th style="text-align: right;">Aanmaakdatum / tijd</th><th></th></tr></thead><tbody></tbody>`);
                const tbody = table.find('tbody');

                otherInvoices.forEach(invoice => {
                    const priceInEuroFormatted = parseFloat(invoice.amountWithTaxes).toFixed(2).replace('.', ',');
                    tbody.append(`<tr>
                                    <td><input type="checkbox" name="invoices[]" value="${invoice.id}" checked style="margin: 0;" /></td>
                                    <td>${invoice.reference ? invoice.reference : ''}</td>
                                    <td style="text-align: right;">&euro; ${priceInEuroFormatted}</td>
                                    <td style="text-align: right;">${moment(invoice.created_at).format('DD-MM-YYYY HH:mm')}</td>
                                    <td style="text-align: right;"><a href="#" onclick="return view_invoice(${invoice.id});" title="Openen" class=""><span class="visual-icon-spyglass"></span></a></td>
                                  </tr>`);
                });

                const button = $(`<button class="button primary">Samenvoegen</button>`);
                elm.find('.squde-popup-html').append(button);
                button.click(async function() {
                    body.isLoading();
                    const invoices = [];
                    tbody.find('input[type="checkbox"]:checked').each(function() {
                        invoices.push($(this).val());
                    });
                    await $.post(`/api/administration/invoices/${id}/merge`, { invoices });
                    body.doneLoading();

                    popup.close();

                    reload_location_if_needed(false);

                    squde_reload_for_flashes();
                });

                tbody.find('input[type="checkbox"]').change(function() {
                    if (tbody.find('input[type="checkbox"]:checked').length === 0) {
                        button.attr('disabled', 'disabled');
                    } else {
                        button.removeAttr('disabled');
                    }
                });
            })
        }
    })();

    return false;
}
